
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { MoveRight } from "lucide-react";
import { Category } from "./types";

interface CategoryMergeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  categories: Category[];
  mergeSource: string;
  setMergeSource: (id: string) => void;
  mergeTarget: string;
  setMergeTarget: (id: string) => void;
  handleMergeCategories: () => void;
}

const CategoryMergeDialog = ({
  open,
  onOpenChange,
  categories,
  mergeSource,
  setMergeSource,
  mergeTarget,
  setMergeTarget,
  handleMergeCategories
}: CategoryMergeDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button variant="outline" className="flex items-center gap-2">
          <MoveRight className="h-4 w-4" />
          <span>Merge Categories</span>
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Merge Categories</DialogTitle>
          <DialogDescription>
            Move all prompts from one category to another. The source category will be archived.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <label htmlFor="source" className="text-sm font-medium">Source Category (will be archived)</label>
            <Select
              value={mergeSource || undefined}
              onValueChange={setMergeSource}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select source category" />
              </SelectTrigger>
              <SelectContent>
                {categories.map((cat) => (
                  <SelectItem key={cat.id} value={cat.id}>
                    {cat.name} ({cat.promptCount} prompts)
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          
          <div className="space-y-2">
            <label htmlFor="target" className="text-sm font-medium">Target Category (destination)</label>
            <Select
              value={mergeTarget || undefined}
              onValueChange={setMergeTarget}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select target category" />
              </SelectTrigger>
              <SelectContent>
                {categories.map((cat) => (
                  <SelectItem 
                    key={cat.id} 
                    value={cat.id}
                    disabled={cat.id === mergeSource}
                  >
                    {cat.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleMergeCategories} variant="destructive">
            Merge Categories
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CategoryMergeDialog;
